import { useMutation } from 'query';
// TODO: fix this import - 82948
import { bookmarkObject } from 'features/bookmark';
import type { CommentBookmarkDeleteAction } from '../../types';
import { useUpdateCommentBookmark } from '../hooks';

export const useBookmarkCommentMutation = () => {
  const updateCommentBookmark = useUpdateCommentBookmark();
  return useMutation<unknown, CommentBookmarkDeleteAction>({
    mutationFn: async ({ id }) => bookmarkObject(id),
    onSuccess(_, params) {
      updateCommentBookmark(params);
    },
  });
};
